
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 117 42"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFFFFE","fill-rule":"evenodd","d":"M116.434 41.513c0-7.882-6.39-14.271-14.271-14.271a14.204 14.204 0 00-8.93 3.143C90 23.879 83.29 19.405 75.535 19.405c-.782 0-1.552.051-2.31.14-2.19-4.756-6.993-8.058-12.571-8.058-2.014 0-3.924.433-5.65 1.206C51.232 5.17 43.453 0 34.46 0 21.772 0 11.487 10.286 11.487 22.974c0 1.485.146 2.935.415 4.342C5.127 28.59 0 34.534 0 41.679h116.43c0-.055.004-.11.004-.166z"}})])
          )
        }
      }
    